export const IMAGE_SIZE_LIMIT = 10 * 1024 * 1024 //10MB
export const IMAGE_SIZE_LIMIT_ERROR = 'Please select an image under 10MB'
